import React from 'react'
import JobDetailsBanner from './components/JobDetailsBanner'
import styles from './jobApplications.module.css'

const JobApplication = () => (
    <div className={styles.page}>
        <JobDetailsBanner />
    </div>
)

export default JobApplication
